import { Button, Card } from "@endya-conformite/ui-kit";
import { useNavigate } from "react-router-dom";
import Report from "@endya-conformite/ui-kit/src/assets/icons/report.svg?react";
import style from "./CardConformite.module.scss";

export function CardConformite() {
  const navigate = useNavigate();
  return (
    <Card className={style.container}>
      <h4>
        <Report />
        Renseigner ma conformité
      </h4>
      <Button variant="outline" onClick={() => navigate("/societes")}>
        Accéder
      </Button>
    </Card>
  );
}
